import React from "react";

export const useProgressHelpers = (progress: number) => {
  const isFinished = React.useMemo(() => {
    return progress >= 1;
  }, [progress]);

  const isInProgress = React.useMemo(() => {
    return progress > 0 && progress < 1;
  }, [progress]);

  return {
    isFinished,
    isInProgress,
  };
};
